import React, {ElementRef, useEffect, useRef} from "react";
import Select from "react-select";
import {FieldRenderProps} from "react-final-form";
import {css} from "@emotion/css";
import {OptionType} from "../../shared/types/widget-types";
import {colors, labelStyle} from "../styles/style-config";
import cn from "classnames";

export const InputSelectAdapter = (props: FieldRenderProps<string>) => {
  const ref = useRef<ElementRef<Select>>(null);

  useEffect(() => {
    if ((props.options ?? []).length === 0) {
      ref.current?.clearValue();
    }
  }, [props.options]);

  const defaultValue = (
    props.options as OptionType<{
      value: string;
      label: string;
    }>[]
  ).find((optionItem) => optionItem.value === props.input.value);
  return (
    <div
      className={cn(css({
          position: "relative",
        }),
        labelStyle)}
    >
      {props.label && <label>{props.label}</label>}
      <Select
        ref={ref}
        className={"widget-select"}
        styles={{
          // @ts-ignore
          control: (base, props) => ({
            ...base,
            boxShadow: "0 !important",
            borderRadius: 8,
            border: '1px solid #A6B4BF',
            fontFamily: "Roboto",
            fontSize: 16,
            fontWeight: 400,
            backgroundColor: "#fff",
          }),
          // @ts-ignore
          menu: (base, props) => ({
            ...base,
            margin: 0,
          }),
          // @ts-ignore
          menuList: (base, props) => ({
            ...base,
            padding: 0,
          }),
          // @ts-ignore
          valueContainer: (base, props) => ({
            ...base,
            padding: '0 8px',
          }),
          // @ts-ignore
          option: (base, props) => ({
            ...base,
            fontSize: 14,
            fontFamily: "OpenHebrew",
            backgroundColor: props.isSelected
              ? colors.widget
              : base.backgroundColor,
            ":hover": {
              cursor: "pointer",
            },
            ":active": {
              backgroundColor: props.isSelected
                ? colors.widget
                : base.backgroundColor,
            },
          }),
          // @ts-ignore
          input: (base, props) => ({
            ...base,
            fontFamily: "OpenHebrew",
            fontSize: 16,
            paddingInline: 8,
            color: defaultValue ? "#000000" : "#FFFFFFB2",
          }),
          // @ts-ignore
          placeholder: (base) => ({
            ...base,
            color: "#C5C5C5",
          }),
          // @ts-ignore
          container: (base) => ({
            "& svg": {
              color: '#5391C6',
              height: 12
            },
          }),
          indicatorsContainer: (base) => ({
            color: "#5391C6",
            "&:hover": {
              color: "#5391C6",
            },
          }),
        }}
        placeholder={props.placeholder}
        value={defaultValue}
        options={props.options}
        onChange={(option) => {
          //@ts-ignore
          props.input.onChange(option?.value);
        }}
      />
    </div>
  );
};
